import SimpleCrypto from 'simple-crypto-js';
import * as config from 'config/config';

const _sc = '88b18f11-171ak=7fb59b592856-Rc4MN6krz1d%';

// encrypting data
export const encrypting = data => {
	try {
		const simpleCrypto = new SimpleCrypto(_sc);
		const decrypt = data ? simpleCrypto.encrypt(data) : '';
		return decrypt;
	} catch (error) {
		console.log(error);
	}
};

// decrypt data
export const decrypting = data => {
	try {
		const simpleCrypto = new SimpleCrypto(_sc);
		const decrypt = data ? simpleCrypto.decrypt(data) : '';
		return decrypt;
	} catch (error) {
		console.log(error);
	}
};

export const checkIfNullOrVal = value => {
	value = typeof value === 'string' ? value.trim() : value;
	return value === 'NULL' || value === '' || value === ' ' || value === undefined || value === null ? null : value;
};

export const requestValidator = params => {
	let error = false;
	config[params?.validatorKey]?.forEach(el => {
		if (!checkIfNullOrVal(params[el.key])) {
			error = true;
		}
	});
	return error;
};
